import { defineStore } from 'pinia';
import useStore from '@/store/index';
import { Promotion } from '@/entities';
import { ref } from 'vue';

export default defineStore('promotion', () => {
  const rootStore = useStore();
  const promotions = ref<Promotion[]>([]);
  const pastPromotions = ref<Promotion[]>([]);
  const isLoading = ref(false);

  return {
    promotions,
    pastPromotions,
    isLoading,

    async init() {},
    async getPromotions() {
      const cmsLocale = rootStore.user.cmsLocale;
      const accountType = rootStore.user.user?.accountType;
      const account = rootStore.user.user?.account;

      const data = await rootStore.apiService.promotion.fetchPromotions(cmsLocale, accountType, account);

      if (data) {
        promotions.value = data.map((promotionData) => new Promotion(promotionData));
      }
    },

    async getPastPromotions() {
      isLoading.value = true;
      const cmsLocale = rootStore.user.cmsLocale;
      const accountType = rootStore.user.user?.accountType;
      const account = rootStore.user.user?.account;

      const data = await rootStore.apiService.promotion.fetchPastPromotions(cmsLocale, accountType, account);

      if (data) {
        pastPromotions.value = data.map((promotionData) => new Promotion(promotionData));
      }

      isLoading.value = false;
    }
  };
});
